const BX = window.BX;

BX.Vue.create({
  name: 'ArmUsedCarsList',
  el: '#usedcars-list',
  data() {
    return {}
  },
  mounted() {
    const swiperProps = {
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      speed: 600,
      effect: 'fade',
    };

    const swiperElements = this.$el.querySelectorAll('.swiper-morecar-item-img');
    swiperElements.forEach((el) => {
      let slider = new Swiper(el, swiperProps);

      const paginationBullet = el.querySelectorAll('.pagination-division .swiper-pagination-bullet');
      paginationBullet.forEach(element => {
        element.addEventListener('mouseover', (event) => {
          let parent = event.target.parentNode;
          let index = Array.prototype.indexOf.call(parent.children, event.target);
          slider.slideTo(index);
        });

        element.addEventListener('click', (event) => {
          event.preventDefault();
          window.location.href = el.getAttribute('data-href');
        });
      });
    });
  },
});